// extracted by mini-css-extract-plugin
export var body = "_mv-8";
export var button = "_mv-0";
export var closeButton = "_mv-5";
export var content = "_mv-3";
export var empty = "_mv-f";
export var grid = "_mv-c";
export var header = "_mv-4";
export var icon = "_mv-1";
export var option = "_mv-d";
export var optionSelected = "_mv-e";
export var overlay = "_mv-2";
export var searchIcon = "_mv-a";
export var searchInput = "_mv-b";
export var searchWrapper = "_mv-9";
export var title = "_mv-6";
export var visuallyHidden = "_mv-7";